// charge bootstrap button
import 'bootstrap/js/dist/button'

import '../../scss/components/realEstateSearchForm.scss'

const repsForm = {
  $f: $('form[name="rep-search-form"]'),

  init () {
    const _this = this

    $.each(_this.$f, function (i, elem) {
      // décheckage des autres éléments pour les checkbox
      if (typeof (_this.$f.find('input:checkbox')) !== 'undefined') {
        $(elem).find('.oneonly').parents('.btn').on('change', function () {
          const $box = $(this).find('input:checkbox')
          const isChecked = $box.is(':checked')
          $(elem).find('input:checkbox[name="' + $box.attr('name') + '"]').prop('checked', false).parent().removeClass('active')
          if (isChecked) {
            $box.prop('checked', true).parent().addClass('active')
          } else {
            $box.prop('checked', false).parent().removeClass('active')
          }
        })
        $(elem).find('input:checkbox:checked').parent().addClass('active')
      }

      // on submit
      $(elem).on('submit', function () {
        let action = $(elem).attr('action')
        const type = $(elem).find('select[name="program_type"]').val()
        const location = $(elem).find('input[name="slug"]').val()
        if (type !== '' && type !== null) { action += '/' + type }
        if (location !== '') { action += '/' + location }
        $(elem).attr('action', action)
      })
    })
  }
}

repsForm.init()
